import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/i18n/langs/index.js'


import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 通过插件的形式挂载，通过全局方法 Vue.use() 使用插件
import domMessage from "./tool/messageOnce.js";
// new 对象实例
const messageOnce = new domMessage()
import ElementUI from 'element-ui'
// 提示
import { save_hint_test, close_hint_test, search_hint_test, close_search_hint_test, disable_hint_test, close_disable_hint_test } from "./tool/tooltip.js"
Vue.prototype.$save_hint_test = save_hint_test // 保存提示
Vue.prototype.$search_hint_test = search_hint_test // 保存提示
Vue.prototype.$close_hint_test = close_hint_test // 关闭保存提示
Vue.prototype.$close_search_hint_test = close_search_hint_test // 关闭保存提示
Vue.prototype.$disable_hint_test = disable_hint_test // 打开禁用提示
Vue.prototype.$close_disable_hint_test = close_disable_hint_test // 关闭禁用提示

import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(ElementUI, {
    enLocale,
    zhLocale
})


// Vue.use(ElementUI, locale, {

//     i18n: ((key, value) => i18n.t(key, value))
// })

// axios
import apiUrl from '../public/config/env.js'
// import axios from '../public/config'
import axios from "./tool/http.js";
// import axios from 'axios'
console.log(apiUrl)

// axios.defaults.baseURL = window.g.base_url

Vue.prototype.$axios = axios

//axios.defaults.base_url = window.g.base_url; //设置基址
// console.log(axios.defaults)
// 表格滚动

import elTableInfiniteScroll from 'el-table-infinite-scroll';

Vue.use(elTableInfiniteScroll);

// qs序列化
import qs from 'qs'
Vue.prototype.$qs = qs
    // 
    // import drag from './tool/drag';
import drag from "v-drag"
Vue.use(drag);
// import $ from 'jquery'
// Vue.prototype.$jq = $
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;
import 'babel-polyfill'; //解决ie浏览器  es6
// 返回定位

(function() {
    //当前页面没有sessionStorage,开启一个新的tab触发
    if (!sessionStorage.length) {
        // alert('111')

        // 这个调用能触发目标事件，从而达到共享数据的目的
        localStorage.setItem('getSessionStorage', Date.now());
        // alert('22222,之前')

    }
    // 该事件是核心  监听storage
    window.addEventListener('storage', function(event) {
        //目的： 触发原页面在localStorage存一下sessionStorage，想起他页面发送行，触发key == 'getSessionStorage'
        // 解释： 再远也没触发事件，将sessionStorage存入localStorage，触发监听并清除
        if (event.key == 'getSessionStorage') {
            // 已存在的标签页会收到这个事件

            // alert('333到这里里的', )
            console.log('999')
            localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
            localStorage.removeItem('sessionStorage');

        } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
            //在tabs页面通过上面吃法，接收sessionStorage参数，监听key == 'sessionStorage'取出存入的sessionStorage，循环存入新的标签
            // alert('2222,刷新后')
            // 新开启的标签页会收到这个事件
            var data = JSON.parse(event.newValue);
            // console.log(event.newValue, '我是路由加载前')

            // value;
            // console.log(data, '8888888888888888')
            for (let key in data) {
                sessionStorage.setItem(key, data[key]);
            }



            //   




        }
    });

})();
setTimeout(() => {
    // sid 验证  路由守卫
    router.beforeEach((to, from, next) => {


        if (to.path === '/login') {

            sessionStorage.removeItem('usermsg')
            sessionStorage.removeItem('leftMenu')
            sessionStorage.removeItem('val')
            sessionStorage.removeItem('judge')
            next();
        } else {


            if (!JSON.parse(sessionStorage.getItem("usermsg"))) {


                messageOnce.warning({
                    message: '请重新登录!',
                    type: 'danger'
                })
                sessionStorage.removeItem('usermsg')
                sessionStorage.removeItem('leftMenu')
                sessionStorage.removeItem('val')
                sessionStorage.removeItem('judge')
                next('/login');
            } else {

                let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

                if (sid === 'null' || sid === '') {
                    // console.log(JSON.parse(sessionStorage.getItem("usermsg")), '555')
                    sessionStorage.removeItem('usermsg')
                    sessionStorage.removeItem('leftMenu')
                    sessionStorage.removeItem('val')
                    sessionStorage.removeItem('judge')
                    next('/login');
                } else {
                    next();
                }
            }

            // console.log(JSON.parse(sessionStorage.getItem('leftMenu')))
            // console.log(to.path, from.path)
            if (to.path !== '/home/zhu' && to.path !== '/home/kongbai') {

                let status = false

                if (sessionStorage.getItem('judge', )) {
                    let judge = JSON.parse(sessionStorage.getItem('judge', ));

                    // console.log(to.path, from.path)
                    judge.forEach((ele) => {
                        // console.log(ele)
                        if (ele.submenu) {
                            ele.submenu.forEach((i) => {
                                if (i.name1 === to.path) {
                                    status = true
                                        // console.log(i.name1, to.path, status)

                                }
                            })
                        } else if (ele.submenu_stair) {
                            ele.submenu_stair.forEach((i) => {
                                if (i.name1 === to.path) {
                                    status = true
                                        // console.log(i.name1, to.path, status)

                                }
                            })
                        }
                    });
                    // console.log(status)
                    if (status) {

                        next()
                        console.log(status)


                        return false

                    } else {


                        (alert('没权限,请重新登录！'))

                        // messageOnce.warning({
                        //     message: '没权限',
                        //     type: 'danger'
                        // })
                        next('/login');
                    }

                }

            }


            // start

        }



        // console.log(judge)
        // 1. 判断是不是登录页面




    });
}, 200);

// console.log(JSON.parse(sessionStorage.getItem("usermsg")), '555')
import veHistogram from 'v-charts/lib/histogram.common'
import vePie from 'v-charts/lib/pie.common'
Vue.component(veHistogram.name, veHistogram);
Vue.component(vePie.name, vePie);
import line from 'v-charts/lib/line.common';
import bar from 'v-charts/lib/bar.common';
Vue.component(line.name, line);
Vue.component(bar.name, bar);
Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
    data() {

        return {
            // mainColor: { key: 'aaa', bg: 'green', font_fimly: "仿宋", }
            jurisdiction: {
                only_query: JSON.parse(sessionStorage.getItem("usermsg")) ? JSON.parse(sessionStorage.getItem("usermsg")).fm_not_readonly : 1,

            }

        }
    },
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')